module.exports = __webpack_public_path__ + "media/images/home/bursaries_icon_2-386b79566218b5f2e3ae49891e27a00d.svg";